<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';

	export let provider: string | undefined;
	export let name: string | undefined;
	export let layout: 'normal' | 'condensed' = 'normal';
</script>

<div
	class="provider-details"
	class:layout-condensed={layout === 'condensed'}
	class:layout-normal={layout === 'normal'}
>
	{#if layout === 'condensed'}
		{#if provider}
			<div class="provider-name">{provider}</div>
		{/if}
		{#if name && name !== provider}
			<div class="tariff-name">{name}</div>
		{/if}
	{:else}
		{#if provider}
			<Text styleType="h2" class="provider-name">{provider}</Text>
		{/if}
		{#if name && name !== provider}
			<Text styleType="body-small" class="tariff-name">{name}</Text>
		{/if}
	{/if}
</div>

<style>
	.provider-details {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.provider-details.layout-condensed {
		gap: 0px !important;
	}

	.provider-details.layout-condensed .provider-name {
		font-size: 11px !important;
		line-height: 1.1 !important;
	}

	.provider-details.layout-condensed .tariff-name {
		font-size: 10px !important;
		line-height: 1.1 !important;
	}

	.provider-name {
		font-size: 12px;
		font-weight: 600;
		line-height: 1.2;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.tariff-name {
		font-size: 11px;
		font-weight: 400;
		opacity: 0.8;
		line-height: 1.2;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	@media (max-width: 768px) {
		.provider-name {
			font-size: 11px;
		}
	}
</style>
